// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"4e5b4aef","710":"9a1d0fd3","807":"3c7d1f12","858":"88c62c4e","868":"f79f8b98"}[chunkId] + ".chunk.css";
};